import { render, staticRenderFns } from "./PuiNextPrev.vue?vue&type=template&id=7a0d3126&"
import script from "./PuiNextPrev.vue?vue&type=script&lang=js&"
export * from "./PuiNextPrev.vue?vue&type=script&lang=js&"
import style0 from "./PuiNextPrev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PuiNextPrev.vue?vue&type=custom&index=0&blockType=description"
if (typeof block0 === 'function') block0(component)
import block1 from "./PuiNextPrev.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && typeof component !== 'undefined' && window.Vue) {
      window.Vue.component('PuiNextPrev', component.exports)
    } export default component.exports